import { getServices } from "../../../api/getServices";
import { EditorSettings } from "../../types/EditorSettings";
import { ViewType } from "../../types/ViewType";
import { getDeviceSettings } from "../selectors/session";
import { AppAction, AppThunkAction } from "../types";

export enum ActionKey {
  SET_DEVICE_SETTINGS = "SET_DEVICE_SETTINGS",
}

interface SetEditorSettingsAction
  extends AppAction<
    ActionKey.SET_DEVICE_SETTINGS,
    {
      settings: EditorSettings;
    }
  > {}

export type EditorSettingsAction = SetEditorSettingsAction;

const setEditorSettings = (
  settings: EditorSettings
): SetEditorSettingsAction => ({
  type: ActionKey.SET_DEVICE_SETTINGS,
  payload: { settings },
});

/** Persist editor settings to Redux and write to disk. */
const writeEditorSettings =
  (settings: EditorSettings): AppThunkAction =>
  dispatch => {
    dispatch(setEditorSettings(settings));
    getServices().kernelStorageClient.writeEditorSettings(settings);
  };

/** Changes view visibility and persists setting to Redux / disk. */
export const setEditorViewVisibility =
  (viewType: ViewType, isVisible: boolean): AppThunkAction =>
  (dispatch, getState) => {
    const settings = getDeviceSettings(getState());
    // Get a filtered copy of view.
    const enabledViews = settings.enabledViews.filter(
      view => view !== viewType
    );

    // Since this is a copy of the original array, its ok to mutate.
    if (isVisible) {
      enabledViews.push(viewType);
    }

    // Sort the view names to keep them consistent.
    enabledViews.sort();

    dispatch(
      writeEditorSettings({
        ...settings,
        enabledViews,
      })
    );
  };

/** Changes view visibility and persists setting to Redux / disk. */
export const setEditorViewExpansion =
  (viewType: ViewType, isExpanded: boolean): AppThunkAction =>
  (dispatch, getState) => {
    const settings = getDeviceSettings(getState());
    // Get a filtered copy of view.
    const expandedViews = settings.expandedViews.filter(
      view => view !== viewType
    );

    // Since this is a copy of the original array, its ok to mutate.
    if (isExpanded) {
      expandedViews.push(viewType);
    }

    // Sort the view names to keep them consistent.
    expandedViews.sort();
    dispatch(
      writeEditorSettings({
        ...settings,
        expandedViews,
      })
    );
  };
